// extracted by mini-css-extract-plugin
export default {"container":"NewCampaignWait_container__Lfs9x","header":"NewCampaignWait_header__VGq+b","mainBody":"NewCampaignWait_mainBody__m-DpS"};